import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const BOItemListModalPr = ({ showModal, closeModal, branch, supplierCode, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/bo_items", {
        params: { branchcode: branch, supplierCode: supplierCode },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filtered = allSuppliers.filter(
        (item) =>
          item.itemmaster_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.itemmaster_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  }, [searchTerm, allSuppliers]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Select Item</h3>

        <div className="search-filter">
          <p>Search Item :</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type to search..."
          />
        </div>

        <div className="search-results">
          <table>
            <thead>
              <tr>
              <th>Branch</th>
                <th>Item Code</th>
                <th>Part No</th>
                <th>Item Type</th>
                <th>Item Name</th>
                <th>Uom</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="loading-text">Loading...</td>
                </tr>
              ) : filteredSuppliers.length > 0 ? (
                filteredSuppliers.map((item) => (
                  <tr key={item.itemmaster_code}>
                    <td>{item.SupplierBranchCode}</td>
                    <td>{item.itemmaster_code}</td>
                    <td>{item.itemmaster_drawingNumber}</td>
                    <td>{item.itemmaster_type}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemMaster_purchaseUom}</td>
                    <td>{item.itemmaster_price}</td>
                    <td>{item.itemmaster_closingStock}</td>
                    <td>
                      <button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="no-data-text">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default BOItemListModalPr;
